const cfg = () => (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export const apiUrl = () =>
  cfg().API_URL || process.env.VUE_APP_API_URL || 'http://localhost:8080';

export const wpbootUrl = () =>
  cfg().SECOND_API_URL || process.env.VUE_APP_SECOND_API_URL || 'http://localhost:8085';
